<div>
  @if (unicodeIcon && unicodeIcon !=='') {
  <label>{{ label || "Select..." }} &#x26A0; </label>
  } @if (!unicodeIcon) {
  <label>{{ label || "Select..." }}</label>
  }
  <div class="ui search selection dropdown" #dropDown>
    <input class="search" autocomplete="off" />
    <div class="text" [ngClass]="{ default: !formCtrl?.value }"></div>
    <div class="menu"></div>
    <i class="chevron down icon"></i>
  </div>
  <input type="hidden" [formControl]="formCtrl" />
</div>
